/** Safe relative path for post-login redirects (blocks open redirects). */
export function resolvePostLoginPath(from, fallback = "/") {
  const path = typeof from === "string" ? from.trim() : "";
  if (path.startsWith("/") && !path.startsWith("//")) {
    return path;
  }
  return fallback;
}
